<div *ngIf="searchText && searchText.length > 0 && entries && entries.length > 0" class="card autocomplete-container"
     role="menu">
  <div class="card-fit text-start">
    <ng-scrollbar style="height: 220px;">
      <ng-container *ngFor="let entry of entries">
        <div (click)="doAutocomplete(entry.name)" class="autocomplete-element">
          <span [style.backgroundColor]="'#' + entry.color" class="dot mr-1"></span>
          <span [innerHTML]="entry.name | truncate : 12"></span>
        </div>
      </ng-container>
    </ng-scrollbar>
  </div>
</div>
